

import Contact from "../contact"
import Banner from "./banner"
import Service from './service'
import Team from "./team"
import Title from "./title"
import Video from './video'
import Price from "./price"
import GoodsGridList from "../goods/gridList"
export default function PageBody({
    body
}){

    console.log('pagebody is ', body)

    return <div>
        {
            body && body?.length > 0 && body.map((b,index) => {
                
                if(b.type === "web_banner") {
                    return <Banner 
                        key={`banner-${index}`}
                        options={b.options}
                        data={b.data}
                    />
                }

                if(b.type === "web_service") {
                    return (
                        <Service 
                            key={`service-${index}`}
                            options={b.options}
                            data={b.data}
                        />
                    )
                }

                if(b.type === "web_team") {
                    return (
                        <Team 
                            key={`team-${index}`}
                            options={b.options}
                            data={b.data}
                        />
                    )
                }

                if(b.type === "web_contact") {
                    return (
                        <Contact 
                            key={`contact-form-${index}`}
                            options={b.options}
                            data={b.data}
                        />
                    )
                }

                if(b.type == "web_title") {
                    return (
                        <Title 
                            key={`title-${index}`}
                            options={b.options}
                            data={b.data}
                        />
                    )
                }

                if(b.type === "web_video") {
                    return (
                        <Video 
                            key={`video-${index}`}
                            options={b.options}
                            data={b.data}
                        />
                    )
                }

                if(b.type === "web_price") {
                    return (
                        <Price 
                            key={`price-${index}`}
                            options={b.options}
                            data={b.data}
                        />
                    )
                }

                if(b.type === "goods_list") {

                    return (
                        <GoodsGridList 
                            is_need_fetch={true}
                            brand_ids={b.options?.brand_ids}
                            category_ids={b.options.category_ids}
                            goods_display_num={b.options.goods_display_num}
                            list={[]}
                        />
                    )
                }
            })
        }
    </div>
}